// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mobile-overlay_wrapper__oeCXc {
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 100%;

  transition: opacity 0.2s;
}

.mobile-overlay_wrapper__oeCXc.mobile-overlay_hidden__ZNahb > *:not(div) {
  opacity: 0;
}

.mobile-overlay_wrapper__oeCXc.mobile-overlay_hidden__ZNahb > div {
  opacity: 1;
}

.mobile-overlay_stepButton__IJekk {
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;

  display: flex;
  flex: 1;
  align-items: center;

  height: 100%;
  border: none;

  color: inherit;

  background: none;
  outline: none;

  -webkit-tap-highlight-color: transparent;
}

.mobile-overlay_stepButton__IJekk:first-child {
  justify-content: flex-end;
}

.mobile-overlay_stepButton__IJekk:last-child {
  justify-content: flex-start;
}

.mobile-overlay_stepButton__IJekk svg {
  width: 20px;
  width: max(20px, min(10%, 42px));
  height: 20px;
  height: max(20px, min(10%, 42px));

  animation: mobile-overlay_fade__f6y1L 1s both;
}

.mobile-overlay_stepButton__IJekk:first-child svg {
  margin-right: 25%;
}

.mobile-overlay_stepButton__IJekk:last-child svg {
  margin-left: 25%;
}

@keyframes mobile-overlay_fade__f6y1L {
  from {
    transform: scale(1);
    opacity: 1;
  }

  to {
    transform: scale(2);
    opacity: 0;
  }
}

@media (prefers-reduced-motion) {
  .mobile-overlay_stepButton__IJekk svg {
    animation: mobile-overlay_noAnimation__XZGEk 1s both;
  }
}

/* Having empty keyframes will show an element without animation,
but will also still trigger onAnimationEnd event. */
/* stylelint-disable block-no-empty */
@keyframes mobile-overlay_noAnimation__XZGEk {
}
`, "",{"version":3,"sources":["webpack://./src/components/mobile-overlay/mobile-overlay.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,OAAO;;EAEP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,WAAW;EACX,YAAY;;EAEZ,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAiB;KAAjB,sBAAiB;UAAjB,iBAAiB;;EAEjB,aAAa;EACb,OAAO;EACP,mBAAmB;;EAEnB,YAAY;EACZ,YAAY;;EAEZ,cAAc;;EAEd,gBAAgB;EAChB,aAAa;;EAEb,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,gCAA6B;EAC7B,YAAY;EACZ,iCAA8B;;EAE9B,6CAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,oDAA8B;EAChC;AACF;;AAEA;mDACmD;AACnD,qCAAqC;AACrC;AACA","sourcesContent":[".wrapper {\n  position: absolute;\n  z-index: -1;\n  top: 0;\n  left: 0;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  width: 100%;\n  height: 100%;\n\n  transition: opacity 0.2s;\n}\n\n.wrapper.hidden > *:not(div) {\n  opacity: 0;\n}\n\n.wrapper.hidden > div {\n  opacity: 1;\n}\n\n.stepButton {\n  user-select: none;\n\n  display: flex;\n  flex: 1;\n  align-items: center;\n\n  height: 100%;\n  border: none;\n\n  color: inherit;\n\n  background: none;\n  outline: none;\n\n  -webkit-tap-highlight-color: transparent;\n}\n\n.stepButton:first-child {\n  justify-content: flex-end;\n}\n\n.stepButton:last-child {\n  justify-content: flex-start;\n}\n\n.stepButton svg {\n  width: 20px;\n  width: clamp(20px, 10%, 42px);\n  height: 20px;\n  height: clamp(20px, 10%, 42px);\n\n  animation: fade 1s both;\n}\n\n.stepButton:first-child svg {\n  margin-right: 25%;\n}\n\n.stepButton:last-child svg {\n  margin-left: 25%;\n}\n\n@keyframes fade {\n  from {\n    transform: scale(1);\n    opacity: 1;\n  }\n\n  to {\n    transform: scale(2);\n    opacity: 0;\n  }\n}\n\n@media (prefers-reduced-motion) {\n  .stepButton svg {\n    animation: noAnimation 1s both;\n  }\n}\n\n/* Having empty keyframes will show an element without animation,\nbut will also still trigger onAnimationEnd event. */\n/* stylelint-disable block-no-empty */\n@keyframes noAnimation {\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `mobile-overlay_wrapper__oeCXc`,
	"hidden": `mobile-overlay_hidden__ZNahb`,
	"stepButton": `mobile-overlay_stepButton__IJekk`,
	"fade": `mobile-overlay_fade__f6y1L`,
	"noAnimation": `mobile-overlay_noAnimation__XZGEk`
};
module.exports = ___CSS_LOADER_EXPORT___;
